import { createContext, Dispatch, SetStateAction } from "react";

export const FieldActionContext = createContext<Dispatch<SetStateAction<Record<number, string[]>>>>(() => {});